var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingApprove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#18AAD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.576 13.2431C13.464 13.4351 13.264 13.5391 13.056 13.5391C12.952 13.5391 12.848 13.5151 12.752 13.4511L10.272 11.9711C9.65595 11.6031 9.19995 10.7951 9.19995 10.0831V6.80312C9.19995 6.47512 9.47195 6.20312 9.79995 6.20312C10.128 6.20312 10.4 6.47512 10.4 6.80312V10.0831C10.4 10.3711 10.64 10.7951 10.888 10.9391L13.368 12.4191C13.656 12.5871 13.752 12.9551 13.576 13.2431Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingApprove);
export default __webpack_public_path__ + "static/media/waiting-approve.68087b302a305fcf708775f64c942502.svg";
export { ForwardRef as ReactComponent };